(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiseaseDeleteController',DiseaseDeleteController);

    DiseaseDeleteController.$inject = ['$uibModalInstance', 'entity', 'Disease'];

    function DiseaseDeleteController($uibModalInstance, entity, Disease) {
        var vm = this;
        vm.disease = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Disease.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
